//import Swiper from 'swiper';
import Swiper from 'swiper/bundle'; // 全ての機能が入っている

document.addEventListener("DOMContentLoaded", function () {

  var galleryThumbs = new Swiper('.slider-thumbnail', {
    spaceBetween: 2,
    slidesPerView: 5,
    loop: true,
    autoHeight: true,
    loopedSlides: 5, //looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  var galleryTop = new Swiper('.slider', {
    spaceBetween: 10,
    speed: 500,
    loop: true,
    zoom: { maxRatio: 2 },
    autoHeight: true,
    effect: 'coverflow',
    loopedSlides: 5, //looped slides should be the same
    navigation: {
      // nextEl: '.swiper-button-next',
      // prevEl: '.swiper-button-prev',
      nextEl: '.swiper-slider1-button-next',
      prevEl: '.swiper-slider1-button-prev',
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });

  var swiperZoomIcon = document.querySelector('.swiper-zoom-icon');
  var swiperZoomTarget = document.querySelector('.slider');

  swiperZoomIcon.addEventListener('click', function (e) {
    galleryTop.zoom.in();
    swiperZoomIcon.classList.add('z_active');
  });
  swiperZoomTarget.addEventListener('mouseout', function (e) {
    galleryTop.zoom.out();
    swiperZoomIcon.classList.remove('z_active');
  });

}, false);